import http from './http'
import { AxiosPromise } from 'axios'
import { SystemConfigEntity } from '../types/systemConfig'
import { ILocaleResponseData } from '../types/locale'
import { AppApiResponseData } from '../types/api'

function getConfigs(): AxiosPromise<
	AppApiResponseData<Array<SystemConfigEntity>>
> {
	return http({
		method: 'GET',
		url: `/system/config`,
	})
}

function getLocale(lang: string): AxiosPromise<ILocaleResponseData> {
	return http({
		method: 'GET',
		url: `/system/language/${lang}`,
	})
}

export { getConfigs, getLocale }
